/**
 * Returns the last four digits of the input string.
 * @param input The string to get the last four digits of.
 */
export function lastFour(input: string): string {
  return input.slice(-4);
}
